import type { ReactElement } from 'react'
import { cloneElement } from 'react'

/**
 * `LLD-SPA-120` — one component, three states baked into one: visible, disabled, with the reason
 * named on the control. "Nothing is hidden, because a hidden control is indistinguishable from a
 * missing feature" (§19.12). Not catalogued separately in process/08-COMPONENT-CATALOGUE.md —
 * it wraps an existing catalogued control (a `Button`) rather than being one itself, the same
 * composition relationship `ErrorAlert` has to `Alert`.
 *
 * `LLD-SPA-121`: the reason names WHEN a capability arrives, never WHICH PLAN carries it — there
 * are no plans, tiers or ceilings at this release (§19.12, §29). Every caller of this component
 * supplies a reason in those terms.
 */
export function GatedControl({ allowed, reason, children }: { allowed: boolean; reason?: string; children: ReactElement<{ disabled?: boolean; title?: string }> }) {
  if (allowed) return children
  return cloneElement(children, { disabled: true, title: reason })
}
